export enum FeatureFlag {
	EnableClientMgtServiceTeamCreation = 'enable_client_mgt_service_team_creation',
}
